import { InjectionToken } from '@angular/core';

export const BROWSER_SERVICE = new InjectionToken<BrowserService>(
  'BROWSER_SERVICE'
);
export const WINDOW_OBJ = new InjectionToken<unknown>('WINDOW_OBJ');

export interface BrowserService {
  openInNewTab(url: string): void;

  changeLocationHref(url: string): void;

  getWindow(): Window | null;

  isBrowser(): boolean;

  copyToClipboard(text: string): Promise<void>;
}
